import React from 'react';

interface Props {
  condition: boolean;
  children: JSX.Element;
}

const Render = ({ condition, children }: Props) => {
  if (condition) return children;

  return null;
};

export default Render;
